<ion-grid class="header-container" fixed>
  <div class="browser-header-main-section" [class.no-search-bar]="hideSearchBar">
    <app-router-link class="logo-container" (click)="hidePopovers()" [path]="[]">
      <div class="logo"></div>
    </app-router-link>

    <div class="header-buttons">
      <div tappable class="header-button cart" [class.hidden]="hideHeaderButtons" (click)="onOpenCartPage()">
        <ion-icon class="header-button-icon" src="/assets/custom-icons/tab-cart.svg"></ion-icon>
        <ion-badge class="header-button-badge" *ngIf="cartItemsCount$ | async as cartItemsCount">{{ cartItemsCount }}</ion-badge>
      </div>
      <div tappable class="header-button contact" [class.hidden]="hideHeaderButtons" (click)="onShowContactPopover($event)">
        <ion-icon class="header-button-icon" src="/assets/custom-icons/tab-contact.svg"></ion-icon>
      </div>
      <div tappable class="header-button account" [class.hidden]="hideHeaderButtons" (click)="onShowAccountPopover($event)">
        <ion-icon class="header-button-icon" src="/assets/custom-icons/tab-account.svg"></ion-icon>
        <ion-badge class="header-button-badge" *ngIf="activeOrdersCount$ | async as activeOrdersCount">{{ activeOrdersCount }}</ion-badge>
      </div>
    </div>
    <div class="search-bar">
      <div tappable class="search-bar-target" (click)="onHandleSearch()">
        <ion-icon class="search-bar-search-icon" src="/assets/custom-icons/vendors-page/search.svg"></ion-icon>
        <span *ngIf="!editableSearchBarInput" class="search-bar-text">
          {{ searchPlaceholder ?? ("SERVICE_TYPE_OPTIONS_PAGE.UNIVERSAL_SEARCH_PLACEHOLDER" | translate) }}
        </span>

        <ion-input
          *ngIf="editableSearchBarInput"
          #searchBar
          clear-input
          enterkeyhint="search"
          class="search-bar-text"
          [placeholder]="searchPlaceholder ?? ('SERVICE_TYPE_OPTIONS_PAGE.UNIVERSAL_SEARCH_PLACEHOLDER' | translate)"
        >
        </ion-input>
      </div>

      <div tappable class="search-bar-button">
        <ng-content select="[searchBarIcon]"></ng-content>
      </div>
    </div>
  </div>

  <ng-content></ng-content>
</ion-grid>

<ion-popover #contactPopover class="contact-popover" [isOpen]="isContactPopoverOpen" (didDismiss)="isContactPopoverOpen = false">
  <ng-template>
    <ion-content>
      <div class="contact-popover-wrapper">
        <ion-button class="feedback" expand="block" color="grey" (click)="onSendFeedback()">
          {{ "CONTACT_PAGE.SEND_FEEDBACK" | translate }}
        </ion-button>

        <div class="contact-links">
          <a [href]="'tel:' + contactPhoneNumber" (click)="onHideContactPopover()">
            <ion-icon src="/assets/custom-icons/phone-grey.svg"></ion-icon>
            <span>{{ contactPhoneNumber }}</span>
          </a>
          <a [href]="'mailto:' + contactEmail + '?subject=' + ('CONTACT_EMAIL_SUBJECT' | translate)" (click)="onHideContactPopover()">
            <ion-icon src="/assets/custom-icons/at-grey.svg"></ion-icon>
            <span>{{ contactEmail }}</span>
          </a>
          <a *ngIf="contactWhatsappUrl" [href]="contactWhatsappUrl" (click)="onHideContactPopover()">
            <ion-icon src="/assets/custom-icons/whatsapp-grey.svg"></ion-icon>
            <span>{{ "TEXT_US" | translate }}</span>
          </a>
        </div>
      </div>
    </ion-content>
  </ng-template>
</ion-popover>

<ion-popover #accountPopover class="account-popover" [isOpen]="isAccountPopoverOpen" (didDismiss)="isAccountPopoverOpen = false">
  <ng-template>
    <ion-content>
      <div class="account-popover-wrapper">
        <ng-container *ngIf="isLoggedIn">
          <div tappable *ngIf="adminUrl" class="my-admin" (click)="openAdminPortal()">
            <ion-icon class="start-icon" src="/assets/custom-icons/b-cog.svg"></ion-icon>
            <div>{{ "ACCOUNT_PAGE.ADMIN" | translate }}</div>
            <ion-icon class="end-icon" icon="/assets/custom-icons/b-angle-right.svg"></ion-icon>
          </div>

          <app-router-link (click)="hidePopovers()" [path]="['user', 'orders']">
            <div class="my-orders">
              <ion-icon class="start-icon" src="/assets/custom-icons/shared/my-orders.svg"></ion-icon>
              <div>{{ "ACCOUNT_PAGE.MY_ORDERS" | translate }}</div>
              <ion-icon class="end-icon" icon="/assets/custom-icons/b-angle-right.svg"></ion-icon>
            </div>
          </app-router-link>

          <app-router-link (click)="hidePopovers()" [path]="['user', 'profile']">
            <div class="my-account-details">
              <ion-icon class="start-icon" src="/assets/custom-icons/shared/my-account-details.svg"></ion-icon>
              <div>{{ "ACCOUNT_PAGE.MY_ACCOUNT_DETAILS" | translate }}</div>
              <ion-icon class="end-icon" icon="/assets/custom-icons/b-angle-right.svg"></ion-icon>
            </div>
          </app-router-link>

          <app-router-link (click)="hidePopovers()" [path]="['user', 'addresses']">
            <div class="my-addresses">
              <ion-icon class="start-icon" src="/assets/custom-icons/shared/my-addresses.svg"></ion-icon>
              <div>{{ "ACCOUNT_PAGE.MY_ADDRESSES" | translate }}</div>
              <ion-icon class="end-icon" icon="/assets/custom-icons/b-angle-right.svg"></ion-icon>
            </div>
          </app-router-link>

          <app-router-link (click)="hidePopovers()" [path]="['wishlists']">
            <div class="my-lists">
              <ion-icon class="start-icon" src="/assets/custom-icons/shared/lists.svg"></ion-icon>
              <div>{{ "ACCOUNT_PAGE.LISTS" | translate }}</div>
              <ion-icon class="end-icon" icon="/assets/custom-icons/b-angle-right.svg"></ion-icon>
            </div>
          </app-router-link>

          <app-router-link (click)="hidePopovers()" [path]="['user', 'wallet']">
            <div class="my-wallet">
              <ion-icon class="start-icon" src="/assets/custom-icons/shared/my-wallet.svg"></ion-icon>
              <div>
                <span>{{ "ACCOUNT_PAGE.MY_WALLET" | translate }}</span>
                <span class="wallet-credits">{{ walletCredits || 0 | localCurrency }}</span>
              </div>
              <ion-icon class="end-icon" icon="/assets/custom-icons/b-angle-right.svg"></ion-icon>
            </div>
          </app-router-link>

          <app-router-link *ngIf="isReferralProgramEnabled" (click)="hidePopovers()" [path]="['referral-program']">
            <div class="referral-program">
              <ion-icon icon="/assets/img/logo.svg"></ion-icon>
              <div>{{ referralProgramMenuText }}</div>
            </div>
          </app-router-link>

          <ion-button class="logout" expand="block" color="grey" (click)="onLogout()">{{ "LOG_OUT" | translate }}</ion-button>
        </ng-container>

        <ng-container *ngIf="!isLoggedIn">
          <ion-button class="login" expand="block" color="green" (click)="onLogin()">
            {{ "LOG_IN" | translate }} / {{ "SIGN_UP" | translate }}
          </ion-button>
        </ng-container>

        <div class="country-language">
          <div tappable class="country" (click)="onChangeCountry()">
            <img [src]="selectedCountryFlagUrl" />
            <span class="country-name">{{ selectedCountry | translate }}</span>
          </div>

          <div tappable class="language" (click)="onChangeLanguage()">
            {{ (selectedLanguageCode === "en" ? "LANGUAGES.ARABIC" : "LANGUAGES.ENGLISH") | translate }}
          </div>
        </div>
      </div>
    </ion-content>
  </ng-template>
</ion-popover>
